import { RootState } from '../reducers';

export const selectExportType = (state: RootState) =>
  state.analytics.exportType;
